(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tasarim"] && !Shopify.designMode) return;
  try {
    
/* =========================================================================
   Onlineetiket.com - Etiket Tasarım Aracı
   Illustrator tarzı: sol araç çubuğu, üst özellik çubuğu, katmanlar,
   gradient/metalize/hologram üretici, PNG/JPG/SVG/PDF dışa aktarma.
   ========================================================================= */
(function () {
  'use strict';

  var HOLOGRAM_STOPS = [
    { offset: 0,    color: '#ff9ad5' },
    { offset: 0.2,  color: '#ffe29a' },
    { offset: 0.4,  color: '#9affc7' },
    { offset: 0.6,  color: '#9ad8ff' },
    { offset: 0.8,  color: '#c79aff' },
    { offset: 1,    color: '#ff9ad5' }
  ];

  function initLabelDesigner(root) {
    if (!root || root.__ldInitialized) return;
    root.__ldInitialized = true;

    /* ---------------- DOM referansları ---------------- */
    var canvas = root.querySelector('[data-label-canvas]');
    var ctx = canvas.getContext('2d');
    var stage = root.querySelector('[data-ld-stage]');
    var sizeReadout = root.querySelector('[data-label-size-readout]');
    var dropHint = root.querySelector('[data-ld-drop-hint]');

    var toolbar = root.querySelector('[data-ld-toolbar]');
    var topbar = root.querySelector('[data-ld-topbar]');

    var fillColorInput = root.querySelector('[data-ld-fill-color]');
    var strokeColorInput = root.querySelector('[data-ld-stroke-color]');
    var strokeWidthInput = root.querySelector('[data-ld-stroke-width]');
    var opacityInput = root.querySelector('[data-label-opacity]');
    var opacityOutput = root.querySelector('[data-ld-opacity-output]');

    var imageInput = root.querySelector('[data-label-image]');
    var imageTriggers = root.querySelectorAll('[data-ld-image-trigger]');

    var widthInput = root.querySelector('[data-label-width]');
    var heightInput = root.querySelector('[data-label-height]');
    var shapeSelect = root.querySelector('[data-label-shape]');
    var bgInput = root.querySelector('[data-label-bg]');
    var finishSelect = root.querySelector('[data-label-finish]');
    var objectColorInput = root.querySelector('[data-label-object-color]');

    var presetButtons = root.querySelectorAll('[data-label-preset]');

    var textField = root.querySelector('[data-label-text]');
    var fontSelect = root.querySelector('[data-label-font]');
    var fontSizeInput = root.querySelector('[data-label-font-size]');
    var boldBtn = root.querySelector('[data-label-bold]');
    var italicBtn = root.querySelector('[data-label-italic]');
    var textAlignBtns = root.querySelectorAll('[data-label-text-align]');

    var duplicateBtn = root.querySelector('[data-label-duplicate]');
    var deleteBtn = root.querySelector('[data-label-delete]');
    var clearBtn = root.querySelector('[data-label-clear]');

    var layersList = root.querySelector('[data-ld-layers-list]');
    var layersEmpty = root.querySelector('[data-ld-layers-empty]');

    var exportFormatSelect = root.querySelector('[data-ld-export-format]');
    var exportDownloadBtn = root.querySelector('[data-ld-export-download]');

    var gradientBaseInput = root.querySelector('[data-ld-gradient-base]');
    var gradientPreview = root.querySelector('[data-ld-gradient-preview]');
    var gradientTargetSelect = root.querySelector('[data-ld-gradient-target]');
    var gradientApplyBtns = root.querySelectorAll('[data-ld-gradient-apply]');

    var popoverToggles = root.querySelectorAll('[data-ld-popover-toggle]');
    var popoverCloses = root.querySelectorAll('[data-ld-popover-close]');
    var popovers = root.querySelectorAll('[data-ld-popover]');

    /* ---------------- Durum (state) ---------------- */
    var uid = 1;
    var state = {
      tool: 'select',
      objects: [],
      selectedId: null,
      mmWidth: parseFloat(widthInput.value) || 80,
      mmHeight: parseFloat(heightInput.value) || 60,
      shape: shapeSelect.value,
      bgColor: bgInput.value,
      finish: finishSelect.value,
      customBgGradient: null,
      defaults: {
        fill: objectColorInput.value,
        stroke: strokeColorInput.value,
        strokeWidth: parseFloat(strokeWidthInput.value) || 2,
        opacity: 1,
        fontFamily: fontSelect.value,
        fontSize: parseFloat(fontSizeInput.value) || 42,
        bold: false,
        italic: false,
        textAlign: 'left',
        text: textField.value || 'Metin'
      }
    };

    var drawingPath = null; // aktif olarak çizilmekte olan yol (pen tool)
    var dragInfo = null;    // {type:'move'|'resize'|'point', obj, startX, startY, orig...}
    var pointerOverStage = false;

    /* ---------------- Yardımcı fonksiyonlar ---------------- */
    function uidNext() { return 'obj_' + (uid++); }

    function labelRect() {
      var padding = 60;
      var availW = canvas.width - padding * 2;
      var availH = canvas.height - padding * 2;
      var ratio = state.mmWidth / state.mmHeight;
      var w = availW, h = availW / ratio;
      if (h > availH) { h = availH; w = availH * ratio; }
      var x = (canvas.width - w) / 2;
      var y = (canvas.height - h) / 2;
      return { x: x, y: y, w: w, h: h };
    }

    function clamp(v, min, max) { return Math.max(min, Math.min(max, v)); }

    function hexToRgba(hex, alpha) {
      var h = hex.replace('#', '');
      if (h.length === 3) h = h.split('').map(function (c) { return c + c; }).join('');
      var r = parseInt(h.substring(0, 2), 16);
      var g = parseInt(h.substring(2, 4), 16);
      var b = parseInt(h.substring(4, 6), 16);
      return 'rgba(' + r + ',' + g + ',' + b + ',' + alpha + ')';
    }

    function buildMetalizeStops(baseColor) {
      return [
        { offset: 0,    color: baseColor },
        { offset: 0.25, color: '#ffffff' },
        { offset: 0.5,  color: baseColor },
        { offset: 0.75, color: '#ffffff' },
        { offset: 1,    color: baseColor }
      ];
    }

    function cssGradientString(stops, angle) {
      var parts = stops.map(function (s) { return s.color + ' ' + Math.round(s.offset * 100) + '%'; });
      return 'linear-gradient(' + (angle || 135) + 'deg, ' + parts.join(', ') + ')';
    }

    function canvasGradientFromFill(fill, bounds) {
      var angleRad = ((fill.angle || 135) - 90) * Math.PI / 180;
      var cx = bounds.x + bounds.w / 2, cy = bounds.y + bounds.h / 2;
      var r = Math.max(bounds.w, bounds.h) / 2;
      var x1 = cx - Math.cos(angleRad) * r, y1 = cy - Math.sin(angleRad) * r;
      var x2 = cx + Math.cos(angleRad) * r, y2 = cy + Math.sin(angleRad) * r;
      var grad = ctx.createLinearGradient(x1, y1, x2, y2);
      fill.stops.forEach(function (s) { grad.addColorStop(clamp(s.offset, 0, 1), s.color); });
      return grad;
    }

    function resolveFillStyle(fill, bounds) {
      if (fill && typeof fill === 'object' && fill.type === 'linear-gradient') {
        return canvasGradientFromFill(fill, bounds);
      }
      return fill;
    }

    /* ---------------- Nesne oluşturma ---------------- */
    function makeName(type, extra) {
      var count = state.objects.filter(function (o) { return o.type === type; }).length + 1;
      var labels = { rect: 'Dikdörtgen', ellipse: 'Elips', line: 'Çizgi', text: 'Metin', image: 'Görsel', path: 'Yol', heart: 'Kalp' };
      return (labels[type] || type) + ' ' + count + (extra ? ' - ' + extra : '');
    }

    function addObject(obj) {
      obj.id = uidNext();
      obj.visible = true;
      obj.locked = false;
      state.objects.push(obj);
      selectObject(obj.id);
      renderLayers();
      redraw();
      return obj;
    }

    function getSelected() {
      return state.objects.find(function (o) { return o.id === state.selectedId; }) || null;
    }

    function selectObject(id) {
      state.selectedId = id;
      syncTopBarFromSelection();
      renderLayers();
      redraw();
    }

    function deleteObject(id) {
      state.objects = state.objects.filter(function (o) { return o.id !== id; });
      if (state.selectedId === id) state.selectedId = null;
      renderLayers();
      redraw();
    }

    function boundsOf(obj) {
      if (obj.type === 'line') {
        return { x: Math.min(obj.x, obj.x2), y: Math.min(obj.y, obj.y2), w: Math.abs(obj.x2 - obj.x), h: Math.abs(obj.y2 - obj.y) };
      }
      if (obj.type === 'path') {
        var xs = obj.points.map(function (p) { return p.x; });
        var ys = obj.points.map(function (p) { return p.y; });
        var minX = Math.min.apply(null, xs), maxX = Math.max.apply(null, xs);
        var minY = Math.min.apply(null, ys), maxY = Math.max.apply(null, ys);
        return { x: minX, y: minY, w: Math.max(1, maxX - minX), h: Math.max(1, maxY - minY) };
      }
      if (obj.type === 'text') {
        ctx.save();
        ctx.font = (obj.italic ? 'italic ' : '') + (obj.bold ? '700 ' : '400 ') + obj.fontSize + 'px ' + obj.fontFamily;
        var w = ctx.measureText(obj.text || ' ').width;
        ctx.restore();
        return { x: obj.x, y: obj.y - obj.fontSize, w: Math.max(w, 10), h: obj.fontSize * 1.25 };
      }
      return { x: obj.x, y: obj.y, w: obj.w, h: obj.h };
    }

    /* ---------------- Çizim (render) ---------------- */
    function drawLabelGuide() {
      var r = labelRect();
      ctx.save();
      ctx.beginPath();
      if (state.shape === 'circle') {
        ctx.ellipse(r.x + r.w / 2, r.y + r.h / 2, r.w / 2, r.h / 2, 0, 0, Math.PI * 2);
      } else if (state.shape === 'round') {
        var rad = Math.min(r.w, r.h) * 0.12;
        roundRectPath(r.x, r.y, r.w, r.h, rad);
      } else {
        ctx.rect(r.x, r.y, r.w, r.h);
      }

      var fillStyle;
      if (state.customBgGradient) {
        fillStyle = canvasGradientFromFill(state.customBgGradient, r);
      } else if (state.finish === 'gold') {
        fillStyle = canvasGradientFromFill({ type: 'linear-gradient', angle: 135, stops: buildMetalizeStops('#caa24a') }, r);
      } else if (state.finish === 'silver') {
        fillStyle = canvasGradientFromFill({ type: 'linear-gradient', angle: 135, stops: buildMetalizeStops('#c7c9cc') }, r);
      } else if (state.finish === 'clear') {
        fillStyle = hexToRgba(state.bgColor, 0.35);
      } else {
        fillStyle = state.bgColor;
      }
      ctx.fillStyle = fillStyle;
      ctx.fill();

      ctx.lineWidth = 1.5;
      ctx.setLineDash([6, 5]);
      ctx.strokeStyle = 'rgba(51,51,51,0.35)';
      ctx.stroke();
      ctx.setLineDash([]);
      ctx.restore();
      return r;
    }

    function roundRectPath(x, y, w, h, r) {
      ctx.moveTo(x + r, y);
      ctx.arcTo(x + w, y, x + w, y + h, r);
      ctx.arcTo(x + w, y + h, x, y + h, r);
      ctx.arcTo(x, y + h, x, y, r);
      ctx.arcTo(x, y, x + w, y, r);
      ctx.closePath();
    }

    function heartPath(x, y, w, h) {
      var topCurveHeight = h * 0.3;
      ctx.moveTo(x + w / 2, y + topCurveHeight);
      ctx.bezierCurveTo(x + w / 2, y, x, y, x, y + topCurveHeight);
      ctx.bezierCurveTo(x, y + (h + topCurveHeight) / 2, x + w / 2, y + (h + topCurveHeight) / 1.3, x + w / 2, y + h);
      ctx.bezierCurveTo(x + w / 2, y + (h + topCurveHeight) / 1.3, x + w, y + (h + topCurveHeight) / 2, x + w, y + topCurveHeight);
      ctx.bezierCurveTo(x + w, y, x + w / 2, y, x + w / 2, y + topCurveHeight);
    }

    function drawObject(obj) {
      if (!obj.visible) return;
      var bounds = boundsOf(obj);
      ctx.save();
      ctx.globalAlpha = obj.opacity != null ? obj.opacity : 1;

      if (obj.type === 'rect') {
        ctx.beginPath();
        ctx.rect(obj.x, obj.y, obj.w, obj.h);
        applyFillStroke(obj, bounds);
      } else if (obj.type === 'ellipse') {
        ctx.beginPath();
        ctx.ellipse(obj.x + obj.w / 2, obj.y + obj.h / 2, Math.abs(obj.w) / 2, Math.abs(obj.h) / 2, 0, 0, Math.PI * 2);
        applyFillStroke(obj, bounds);
      } else if (obj.type === 'heart') {
        ctx.beginPath();
        heartPath(obj.x, obj.y, obj.w, obj.h);
        applyFillStroke(obj, bounds);
      } else if (obj.type === 'line') {
        ctx.beginPath();
        ctx.moveTo(obj.x, obj.y);
        ctx.lineTo(obj.x2, obj.y2);
        ctx.lineCap = 'round';
        ctx.strokeStyle = resolveFillStyle(obj.stroke, bounds);
        ctx.lineWidth = obj.strokeWidth || 2;
        ctx.stroke();
      } else if (obj.type === 'path') {
        if (obj.points.length > 1) {
          ctx.beginPath();
          ctx.moveTo(obj.points[0].x, obj.points[0].y);
          for (var i = 1; i < obj.points.length; i++) ctx.lineTo(obj.points[i].x, obj.points[i].y);
          if (obj.closed) ctx.closePath();
          ctx.lineJoin = 'round';
          ctx.lineCap = 'round';
          if (obj.closed && obj.fill) {
            ctx.fillStyle = resolveFillStyle(obj.fill, bounds);
            ctx.fill();
          }
          ctx.strokeStyle = resolveFillStyle(obj.stroke, bounds);
          ctx.lineWidth = obj.strokeWidth || 2;
          ctx.stroke();
        }
      } else if (obj.type === 'text') {
        ctx.font = (obj.italic ? 'italic ' : '') + (obj.bold ? '700 ' : '400 ') + obj.fontSize + 'px ' + obj.fontFamily;
        ctx.textBaseline = 'alphabetic';
        ctx.textAlign = obj.textAlign || 'left';
        ctx.fillStyle = resolveFillStyle(obj.fill, bounds);
        var tx = obj.x;
        if (obj.textAlign === 'center') tx = obj.x + bounds.w / 2;
        if (obj.textAlign === 'right') tx = obj.x + bounds.w;
        ctx.fillText(obj.text, tx, obj.y);
      } else if (obj.type === 'image' && obj.img) {
        ctx.drawImage(obj.img, obj.x, obj.y, obj.w, obj.h);
      }

      ctx.restore();

      if (obj.id === state.selectedId) drawSelectionHandles(obj, bounds);
    }

    function applyFillStroke(obj, bounds) {
      if (obj.fill && obj.fill !== 'none') {
        ctx.fillStyle = resolveFillStyle(obj.fill, bounds);
        ctx.fill();
      }
      if (obj.strokeWidth > 0) {
        ctx.strokeStyle = resolveFillStyle(obj.stroke, bounds);
        ctx.lineWidth = obj.strokeWidth;
        ctx.stroke();
      }
    }

    var HANDLE_SIZE = 9;
    function drawSelectionHandles(obj, bounds) {
      ctx.save();
      ctx.strokeStyle = '#69d0cf';
      ctx.lineWidth = 1.5;
      ctx.setLineDash([4, 3]);
      ctx.strokeRect(bounds.x - 2, bounds.y - 2, bounds.w + 4, bounds.h + 4);
      ctx.setLineDash([]);

      ctx.fillStyle = '#69d0cf';
      if (obj.type === 'line') {
        [[obj.x, obj.y], [obj.x2, obj.y2]].forEach(function (p) {
          ctx.fillRect(p[0] - HANDLE_SIZE / 2, p[1] - HANDLE_SIZE / 2, HANDLE_SIZE, HANDLE_SIZE);
        });
      } else if (obj.type !== 'path') {
        var hx = bounds.x + bounds.w, hy = bounds.y + bounds.h;
        ctx.fillRect(hx - HANDLE_SIZE / 2, hy - HANDLE_SIZE / 2, HANDLE_SIZE, HANDLE_SIZE);
      }
      ctx.restore();
    }

    function redraw() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      drawLabelGuide();
      state.objects.forEach(drawObject);

      if (drawingPath && drawingPath.points.length) {
        ctx.save();
        ctx.beginPath();
        ctx.moveTo(drawingPath.points[0].x, drawingPath.points[0].y);
        for (var i = 1; i < drawingPath.points.length; i++) ctx.lineTo(drawingPath.points[i].x, drawingPath.points[i].y);
        ctx.strokeStyle = drawingPath.stroke;
        ctx.lineWidth = drawingPath.strokeWidth || 2;
        ctx.setLineDash([3, 3]);
        ctx.stroke();
        ctx.setLineDash([]);
        ctx.restore();
      }
    }

    /* ---------------- Boyut / etiket okuma ---------------- */
    function updateSizeReadout() {
      sizeReadout.textContent = state.mmWidth + ' x ' + state.mmHeight + ' mm';
    }

    /* ---------------- Katmanlar paneli ---------------- */
    function renderLayers() {
      layersList.innerHTML = '';
      var items = state.objects.slice().reverse();
      layersEmpty.style.display = items.length ? 'none' : 'block';
      items.forEach(function (obj) {
        var li = document.createElement('li');
        li.className = 'ld-layer' + (obj.id === state.selectedId ? ' is-selected' : '') + (!obj.visible ? ' is-hidden' : '');
        li.innerHTML =
          '<button type="button" data-act="visibility" title="Görünürlük">' +
            (obj.visible
              ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7-10-7-10-7z"/><circle cx="12" cy="12" r="3"/></svg>'
              : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M3 3l18 18"/><path d="M10.6 5.2A10.5 10.5 0 0 1 12 5c6 0 10 7 10 7a17 17 0 0 1-3.2 4M6.6 6.6C4 8.3 2 12 2 12s4 7 10 7c1.3 0 2.5-.3 3.6-.7"/></svg>') +
          '</button>' +
          '<span class="ld-layer__name" data-act="rename" title="Yeniden adlandırmak için çift tıklayın">' + (obj.name || obj.type) + '</span>' +
          '<button type="button" data-act="up" title="Öne al"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 5v14M5 12l7-7 7 7"/></svg></button>' +
          '<button type="button" data-act="down" title="Arkaya al"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 19V5M5 12l7 7 7-7"/></svg></button>' +
          '<button type="button" data-act="delete" title="Sil"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13"/></svg></button>';

        li.addEventListener('click', function (e) {
          var act = e.target.closest('[data-act]');
          if (!act) return;
          var kind = act.getAttribute('data-act');
          if (kind === 'visibility') { obj.visible = !obj.visible; renderLayers(); redraw(); return; }
          if (kind === 'up') { moveLayer(obj.id, 1); return; }
          if (kind === 'down') { moveLayer(obj.id, -1); return; }
          if (kind === 'delete') { deleteObject(obj.id); return; }
          if (kind !== 'rename') selectObject(obj.id);
        });
        li.querySelector('[data-act="rename"]').addEventListener('dblclick', function () {
          var newName = window.prompt('Katman adı:', obj.name || '');
          if (newName) { obj.name = newName; renderLayers(); }
        });

        layersList.appendChild(li);
      });
    }

    function moveLayer(id, dir) {
      var idx = state.objects.findIndex(function (o) { return o.id === id; });
      if (idx === -1) return;
      var newIdx = clamp(idx + dir, 0, state.objects.length - 1);
      if (newIdx === idx) return;
      var arr = state.objects;
      var tmp = arr[idx]; arr[idx] = arr[newIdx]; arr[newIdx] = tmp;
      renderLayers();
      redraw();
    }

    /* ---------------- Üst çubuk <-> seçim senkronizasyonu ---------------- */
    function syncTopBarFromSelection() {
      var obj = getSelected();
      if (!obj) {
        fillColorInput.value = typeof state.defaults.fill === 'string' ? state.defaults.fill : '#69d0cf';
        strokeColorInput.value = state.defaults.stroke;
        strokeWidthInput.value = state.defaults.strokeWidth;
        opacityInput.value = Math.round(state.defaults.opacity * 100);
      } else {
        var fillVal = typeof obj.fill === 'string' ? obj.fill : '#69d0cf';
        fillColorInput.value = fillVal;
        strokeColorInput.value = typeof obj.stroke === 'string' ? obj.stroke : '#000000';
        strokeWidthInput.value = obj.strokeWidth != null ? obj.strokeWidth : 0;
        opacityInput.value = Math.round((obj.opacity != null ? obj.opacity : 1) * 100);
      }
      opacityOutput.textContent = opacityInput.value + '%';
      syncTextPopoverFromSelection();
    }

    function syncTextPopoverFromSelection() {
      var obj = getSelected();
      var isText = obj && obj.type === 'text';
      var src = isText ? obj : state.defaults;
      textField.value = isText ? obj.text : state.defaults.text;
      fontSelect.value = src.fontFamily;
      fontSizeInput.value = src.fontSize;
      boldBtn.classList.toggle('is-active', !!src.bold);
      italicBtn.classList.toggle('is-active', !!src.italic);
      textAlignBtns.forEach(function (b) {
        b.classList.toggle('is-active', (src.textAlign || 'left') === b.getAttribute('data-label-text-align'));
      });
    }

    /* ---------------- Araç (tool) seçimi ---------------- */
    function setTool(tool) {
      state.tool = tool;
      toolbar.querySelectorAll('[data-ld-tool]').forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-ld-tool') === tool);
      });
      canvas.style.cursor = (tool === 'select') ? 'default' : 'crosshair';
      if (tool !== 'pen' && drawingPath) finishPath(false);
    }

    toolbar.querySelectorAll('[data-ld-tool]').forEach(function (btn) {
      btn.addEventListener('click', function () { setTool(btn.getAttribute('data-ld-tool')); });
    });

    /* ---------------- Klavye kısayolları ---------------- */
    var SHORTCUTS = { v: 'select', p: 'pen', t: 'text', m: 'rect', l: 'ellipse', h: 'heart', '\\': 'line' };
    document.addEventListener('keydown', function (e) {
      if (!pointerOverStage && document.activeElement !== canvas) return;
      var tag = (document.activeElement && document.activeElement.tagName) || '';
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return;

      if (e.key === 'Escape') { if (drawingPath) finishPath(false); return; }
      if (e.key === 'Enter') { if (drawingPath) finishPath(false); return; }
      if (e.key === 'Delete' || e.key === 'Backspace') {
        if (state.selectedId) { e.preventDefault(); deleteObject(state.selectedId); }
        return;
      }
      if (e.key.startsWith('Arrow') && state.selectedId) {
        var obj = getSelected();
        if (!obj) return;
        var step = e.shiftKey ? 10 : 1;
        var dx = e.key === 'ArrowLeft' ? -step : e.key === 'ArrowRight' ? step : 0;
        var dy = e.key === 'ArrowUp' ? -step : e.key === 'ArrowDown' ? step : 0;
        translateObject(obj, dx, dy);
        redraw();
        e.preventDefault();
        return;
      }
      var key = e.key.toLowerCase();
      if (SHORTCUTS[key]) { setTool(SHORTCUTS[key]); }
    });

    stage.addEventListener('mouseenter', function () { pointerOverStage = true; });
    stage.addEventListener('mouseleave', function () { pointerOverStage = false; });

    function translateObject(obj, dx, dy) {
      if (obj.type === 'line') { obj.x += dx; obj.y += dy; obj.x2 += dx; obj.y2 += dy; }
      else if (obj.type === 'path') { obj.points.forEach(function (p) { p.x += dx; p.y += dy; }); }
      else { obj.x += dx; obj.y += dy; }
    }

    /* ---------------- Canvas koordinat dönüşümü ---------------- */
    function canvasPoint(e) {
      var rect = canvas.getBoundingClientRect();
      var scaleX = canvas.width / rect.width;
      var scaleY = canvas.height / rect.height;
      var clientX = (e.touches ? e.touches[0].clientX : e.clientX);
      var clientY = (e.touches ? e.touches[0].clientY : e.clientY);
      return { x: (clientX - rect.left) * scaleX, y: (clientY - rect.top) * scaleY };
    }

    function hitTest(x, y) {
      for (var i = state.objects.length - 1; i >= 0; i--) {
        var obj = state.objects[i];
        if (!obj.visible) continue;
        var b = boundsOf(obj);
        if (obj.type === 'ellipse') {
          var rx = obj.w / 2, ry = obj.h / 2, cx = obj.x + rx, cy = obj.y + ry;
          if (rx <= 0 || ry <= 0) continue;
          var nx = (x - cx) / rx, ny = (y - cy) / ry;
          if (nx * nx + ny * ny <= 1) return obj;
          continue;
        }
        if (obj.type === 'line') {
          if (distToSegment(x, y, obj.x, obj.y, obj.x2, obj.y2) < 8) return obj;
          continue;
        }
        if (x >= b.x - 4 && x <= b.x + b.w + 4 && y >= b.y - 4 && y <= b.y + b.h + 4) return obj;
      }
      return null;
    }

    function distToSegment(px, py, x1, y1, x2, y2) {
      var A = px - x1, B = py - y1, C = x2 - x1, D = y2 - y1;
      var dot = A * C + B * D, lenSq = C * C + D * D;
      var t = lenSq ? clamp(dot / lenSq, 0, 1) : 0;
      var ex = x1 + t * C, ey = y1 + t * D;
      return Math.hypot(px - ex, py - ey);
    }

    function handleAt(obj, x, y) {
      if (state.selectedId !== obj.id) return null;
      var b = boundsOf(obj);
      if (obj.type === 'line') {
        if (Math.hypot(x - obj.x, y - obj.y) < HANDLE_SIZE) return 'p1';
        if (Math.hypot(x - obj.x2, y - obj.y2) < HANDLE_SIZE) return 'p2';
        return null;
      }
      if (obj.type === 'path') return null;
      var hx = b.x + b.w, hy = b.y + b.h;
      if (Math.hypot(x - hx, y - hy) < HANDLE_SIZE) return 'resize';
      return null;
    }

    /* ---------------- Pen (yol) aracı ---------------- */
    function startOrContinuePath(pt) {
      if (!drawingPath) {
        drawingPath = { points: [{ x: pt.x, y: pt.y }], stroke: strokeColorInput.value, strokeWidth: parseFloat(strokeWidthInput.value) || 2, fill: fillColorInput.value };
        redraw();
        return;
      }
      var first = drawingPath.points[0];
      if (drawingPath.points.length > 1 && Math.hypot(pt.x - first.x, pt.y - first.y) < 10) {
        drawingPath.closed = true;
        finishPath(true);
        return;
      }
      drawingPath.points.push({ x: pt.x, y: pt.y });
      redraw();
    }

    function finishPath(keep) {
      if (drawingPath && drawingPath.points.length > 1 && keep !== false) {
        var obj = {
          type: 'path',
          points: drawingPath.points,
          closed: !!drawingPath.closed,
          stroke: drawingPath.stroke,
          strokeWidth: drawingPath.strokeWidth,
          fill: drawingPath.closed ? drawingPath.fill : 'none',
          opacity: state.defaults.opacity,
          name: makeName('path')
        };
        drawingPath = null;
        addObject(obj);
        setTool('select');
        return;
      }
      drawingPath = null;
      redraw();
    }

    canvas.addEventListener('dblclick', function (e) {
      if (state.tool === 'pen' && drawingPath) { finishPath(true); return; }
      var pt = canvasPoint(e);
      var obj = hitTest(pt.x, pt.y);
      if (obj && obj.type === 'text') {
        var newText = window.prompt('Metni düzenle:', obj.text);
        if (newText !== null) { obj.text = newText; redraw(); }
      }
    });

    /* ---------------- Fare etkileşimleri ---------------- */
    canvas.addEventListener('mousedown', function (e) {
      canvas.focus();
      var pt = canvasPoint(e);

      if (state.tool === 'pen') { startOrContinuePath(pt); return; }

      if (state.tool === 'text') {
        var textObj = addObject({
          type: 'text', x: pt.x, y: pt.y,
          text: state.defaults.text || 'Metin',
          fontFamily: state.defaults.fontFamily, fontSize: state.defaults.fontSize,
          bold: state.defaults.bold, italic: state.defaults.italic, textAlign: state.defaults.textAlign,
          fill: fillColorInput.value, opacity: state.defaults.opacity,
          name: makeName('text')
        });
        textObj.name = makeName('text');
        setTool('select');
        return;
      }

      if (state.tool === 'heart') {
        addObject({
          type: 'heart', x: pt.x - 60, y: pt.y - 55, w: 120, h: 110,
          fill: fillColorInput.value, stroke: strokeColorInput.value,
          strokeWidth: parseFloat(strokeWidthInput.value) || 0,
          opacity: state.defaults.opacity, name: makeName('heart')
        });
        setTool('select');
        return;
      }

      if (state.tool === 'rect' || state.tool === 'ellipse' || state.tool === 'line') {
        var newObj = {
          type: state.tool, x: pt.x, y: pt.y, w: 0, h: 0,
          x2: pt.x, y2: pt.y,
          fill: fillColorInput.value, stroke: strokeColorInput.value,
          strokeWidth: parseFloat(strokeWidthInput.value) || 0,
          opacity: state.defaults.opacity
        };
        newObj.id = uidNext();
        newObj.visible = true; newObj.locked = false;
        newObj.name = makeName(state.tool);
        state.objects.push(newObj);
        state.selectedId = newObj.id;
        dragInfo = { type: 'draw', obj: newObj, startX: pt.x, startY: pt.y };
        return;
      }

      // select tool
      var hit = hitTest(pt.x, pt.y);
      if (hit) {
        var handle = handleAt(hit, pt.x, pt.y);
        selectObject(hit.id);
        if (handle) {
          dragInfo = { type: 'handle', handle: handle, obj: hit, startX: pt.x, startY: pt.y, orig: JSON.parse(JSON.stringify(hit)) };
        } else {
          dragInfo = { type: 'move', obj: hit, startX: pt.x, startY: pt.y, orig: JSON.parse(JSON.stringify(hit)) };
        }
      } else {
        selectObject(null);
      }
    });

    canvas.addEventListener('mousemove', function (e) {
      var pt = canvasPoint(e);

      if (drawingPath) {
        var preview = drawingPath.points.slice();
        redraw();
        ctx.save();
        ctx.beginPath();
        ctx.moveTo(preview[preview.length - 1].x, preview[preview.length - 1].y);
        ctx.lineTo(pt.x, pt.y);
        ctx.strokeStyle = 'rgba(105,208,207,0.7)';
        ctx.setLineDash([3, 3]);
        ctx.stroke();
        ctx.restore();
        return;
      }

      if (!dragInfo) return;
      var dx = pt.x - dragInfo.startX, dy = pt.y - dragInfo.startY;

      if (dragInfo.type === 'draw') {
        var o = dragInfo.obj;
        if (o.type === 'line') { o.x2 = pt.x; o.y2 = pt.y; }
        else { o.w = pt.x - o.x; o.h = pt.y - o.y; }
        redraw();
        return;
      }

      if (dragInfo.type === 'move') {
        var orig = dragInfo.orig;
        if (orig.type === 'line') {
          dragInfo.obj.x = orig.x + dx; dragInfo.obj.y = orig.y + dy;
          dragInfo.obj.x2 = orig.x2 + dx; dragInfo.obj.y2 = orig.y2 + dy;
        } else if (orig.type === 'path') {
          dragInfo.obj.points = orig.points.map(function (p) { return { x: p.x + dx, y: p.y + dy }; });
        } else {
          dragInfo.obj.x = orig.x + dx; dragInfo.obj.y = orig.y + dy;
        }
        redraw();
        return;
      }

      if (dragInfo.type === 'handle') {
        var orig2 = dragInfo.orig;
        if (dragInfo.handle === 'resize') {
          dragInfo.obj.w = Math.max(6, orig2.w + dx);
          dragInfo.obj.h = Math.max(6, orig2.h + dy);
        } else if (dragInfo.handle === 'p1') {
          dragInfo.obj.x = orig2.x + dx; dragInfo.obj.y = orig2.y + dy;
        } else if (dragInfo.handle === 'p2') {
          dragInfo.obj.x2 = orig2.x2 + dx; dragInfo.obj.y2 = orig2.y2 + dy;
        }
        redraw();
      }
    });

    function endDrag() {
      if (dragInfo && dragInfo.type === 'draw') {
        var o = dragInfo.obj;
        if (o.type !== 'line' && (Math.abs(o.w) < 4 || Math.abs(o.h) < 4)) {
          deleteObject(o.id);
        } else {
          if (o.w < 0) { o.x += o.w; o.w = Math.abs(o.w); }
          if (o.h < 0) { o.y += o.h; o.h = Math.abs(o.h); }
          renderLayers();
        }
        setTool('select');
      }
      dragInfo = null;
    }
    window.addEventListener('mouseup', endDrag);

    /* ---------------- Sürükle-bırak ile görsel yükleme ---------------- */
    ['dragenter', 'dragover'].forEach(function (evt) {
      stage.addEventListener(evt, function (e) {
        e.preventDefault();
        stage.classList.add('is-drag-over');
        dropHint.hidden = false;
      });
    });
    ['dragleave', 'drop'].forEach(function (evt) {
      stage.addEventListener(evt, function (e) {
        if (evt === 'dragleave' && e.target !== stage) return;
        stage.classList.remove('is-drag-over');
        dropHint.hidden = true;
      });
    });
    stage.addEventListener('drop', function (e) {
      e.preventDefault();
      var file = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
      if (file) loadImageFile(file);
    });

    imageTriggers.forEach(function (btn) { btn.addEventListener('click', function () { imageInput.click(); }); });
    imageInput.addEventListener('change', function () {
      var file = imageInput.files && imageInput.files[0];
      if (file) loadImageFile(file);
      imageInput.value = '';
    });

    function loadImageFile(file) {
      if (!/^image\//.test(file.type)) return;
      var reader = new FileReader();
      reader.onload = function (ev) {
        var img = new Image();
        img.onload = function () {
          var maxDim = 320;
          var ratio = Math.min(maxDim / img.width, maxDim / img.height, 1);
          var w = img.width * ratio, h = img.height * ratio;
          var r = labelRect();
          addObject({
            type: 'image', img: img, x: r.x + (r.w - w) / 2, y: r.y + (r.h - h) / 2,
            w: w, h: h, opacity: state.defaults.opacity, name: makeName('image')
          });
        };
        img.src = ev.target.result;
      };
      reader.readAsDataURL(file);
    }

    /* ---------------- Üst çubuk kontrolleri ---------------- */
    fillColorInput.addEventListener('input', function () {
      var obj = getSelected();
      if (obj) { obj.fill = fillColorInput.value; }
      else { state.defaults.fill = fillColorInput.value; objectColorInput.value = fillColorInput.value; }
      redraw();
    });
    strokeColorInput.addEventListener('input', function () {
      var obj = getSelected();
      if (obj) { obj.stroke = strokeColorInput.value; }
      else { state.defaults.stroke = strokeColorInput.value; }
      redraw();
    });
    strokeWidthInput.addEventListener('input', function () {
      var val = parseFloat(strokeWidthInput.value) || 0;
      var obj = getSelected();
      if (obj) { obj.strokeWidth = val; }
      else { state.defaults.strokeWidth = val; }
      redraw();
    });
    opacityInput.addEventListener('input', function () {
      var val = clamp(parseFloat(opacityInput.value) || 100, 10, 100) / 100;
      opacityOutput.textContent = Math.round(val * 100) + '%';
      var obj = getSelected();
      if (obj) { obj.opacity = val; }
      else { state.defaults.opacity = val; }
      redraw();
    });

    /* ---------------- Hizalama ---------------- */
    root.querySelectorAll('[data-ld-align-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var obj = getSelected();
        if (!obj) return;
        var mode = btn.getAttribute('data-ld-align-btn');
        var guide = labelRect();
        var b = boundsOf(obj);
        var dx = 0, dy = 0;
        if (mode === 'left') dx = guide.x - b.x;
        if (mode === 'right') dx = (guide.x + guide.w) - (b.x + b.w);
        if (mode === 'h-center') dx = (guide.x + guide.w / 2) - (b.x + b.w / 2);
        if (mode === 'top') dy = guide.y - b.y;
        if (mode === 'bottom') dy = (guide.y + guide.h) - (b.y + b.h);
        if (mode === 'v-center') dy = (guide.y + guide.h / 2) - (b.y + b.h / 2);
        translateObject(obj, dx, dy);
        redraw();
      });
    });

    /* ---------------- Popover'lar (Metin / Gradient) ---------------- */
    function closeAllPopovers() { popovers.forEach(function (p) { p.hidden = true; }); }
    popoverToggles.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var name = btn.getAttribute('data-ld-popover-toggle');
        var target = root.querySelector('[data-ld-popover="' + name + '"]');
        var willOpen = target.hidden;
        closeAllPopovers();
        target.hidden = !willOpen;
      });
    });
    var gradientToggleBtn = root.querySelector('[data-ld-gradient-toggle]');
    if (gradientToggleBtn) {
      gradientToggleBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        var target = root.querySelector('[data-ld-popover="gradient"]');
        var willOpen = target.hidden;
        closeAllPopovers();
        target.hidden = !willOpen;
        updateGradientPreview();
      });
    }
    popoverCloses.forEach(function (btn) {
      btn.addEventListener('click', function () { btn.closest('[data-ld-popover]').hidden = true; });
    });
    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) return;
      popovers.forEach(function (p) {
        if (p.hidden) return;
        if (!p.contains(e.target) && !e.target.closest('[data-ld-popover-toggle]') && !e.target.closest('[data-ld-gradient-toggle]')) {
          p.hidden = true;
        }
      });
    });

    /* ---------------- Metin popover alanları ---------------- */
    textField.addEventListener('input', function () {
      var obj = getSelected();
      if (obj && obj.type === 'text') { obj.name = makeName('text'); obj.text = textField.value; }
      else { state.defaults.text = textField.value; }
      redraw();
    });
    fontSelect.addEventListener('change', function () {
      var obj = getSelected();
      if (obj && obj.type === 'text') obj.fontFamily = fontSelect.value; else state.defaults.fontFamily = fontSelect.value;
      redraw();
    });
    fontSizeInput.addEventListener('input', function () {
      var val = parseFloat(fontSizeInput.value);
      var obj = getSelected();
      if (obj && obj.type === 'text') obj.fontSize = val; else state.defaults.fontSize = val;
      redraw();
    });
    boldBtn.addEventListener('click', function () {
      var obj = getSelected();
      if (obj && obj.type === 'text') obj.bold = !obj.bold; else state.defaults.bold = !state.defaults.bold;
      syncTextPopoverFromSelection();
      redraw();
    });
    italicBtn.addEventListener('click', function () {
      var obj = getSelected();
      if (obj && obj.type === 'text') obj.italic = !obj.italic; else state.defaults.italic = !state.defaults.italic;
      syncTextPopoverFromSelection();
      redraw();
    });
    textAlignBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var align = btn.getAttribute('data-label-text-align');
        var obj = getSelected();
        if (obj && obj.type === 'text') obj.textAlign = align; else state.defaults.textAlign = align;
        syncTextPopoverFromSelection();
        redraw();
      });
    });

    /* ---------------- Gradient / Metalize / Hologram ---------------- */
    function updateGradientPreview() {
      var stops = buildMetalizeStops(gradientBaseInput.value);
      gradientPreview.style.background = cssGradientString(stops, 135);
    }
    if (gradientBaseInput) gradientBaseInput.addEventListener('input', updateGradientPreview);

    gradientApplyBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var mode = btn.getAttribute('data-ld-gradient-apply');
        var stops = mode === 'hologram' ? HOLOGRAM_STOPS : buildMetalizeStops(gradientBaseInput.value);
        var gradientFill = { type: 'linear-gradient', angle: mode === 'hologram' ? 120 : 135, stops: stops };
        var target = gradientTargetSelect.value;

        if (target === 'background') {
          state.customBgGradient = gradientFill;
        } else {
          var obj = getSelected();
          if (!obj) { window.alert('Önce bir obje seçin ya da hedefi "Etiket zemini" yapın.'); return; }
          obj.fill = gradientFill;
        }
        redraw();
      });
    });

    // Zemin rengini elle değiştirince özel gradient'i temizle
    bgInput.addEventListener('input', function () { state.customBgGradient = null; state.bgColor = bgInput.value; redraw(); });
    finishSelect.addEventListener('change', function () { state.customBgGradient = null; state.finish = finishSelect.value; redraw(); });

    /* ---------------- Temel ayar alanları ---------------- */
    widthInput.addEventListener('input', function () { state.mmWidth = parseFloat(widthInput.value) || state.mmWidth; updateSizeReadout(); redraw(); });
    heightInput.addEventListener('input', function () { state.mmHeight = parseFloat(heightInput.value) || state.mmHeight; updateSizeReadout(); redraw(); });
    shapeSelect.addEventListener('change', function () { state.shape = shapeSelect.value; redraw(); });
    objectColorInput.addEventListener('input', function () {
      state.defaults.fill = objectColorInput.value;
      if (!getSelected()) fillColorInput.value = objectColorInput.value;
    });

    presetButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        presetButtons.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var preset = btn.getAttribute('data-label-preset');
        if (preset === 'classic') {
          shapeSelect.value = 'rect'; state.shape = 'rect';
          bgInput.value = '#ffffff'; state.bgColor = '#ffffff';
          finishSelect.value = 'solid'; state.finish = 'solid';
        } else if (preset === 'cosmetic') {
          shapeSelect.value = 'round'; state.shape = 'round';
          bgInput.value = '#f6f1ea'; state.bgColor = '#f6f1ea';
          finishSelect.value = 'solid'; state.finish = 'solid';
        }
        state.customBgGradient = null;
        redraw();
      });
    });

    /* ---------------- Kopyala / Sil / Temizle ---------------- */
    duplicateBtn.addEventListener('click', function () {
      var obj = getSelected();
      if (!obj) return;
      var clone = JSON.parse(JSON.stringify(obj));
      clone.img = obj.img; // JSON.parse kopyalayamaz, referansı geri koy
      if (clone.type === 'line') { clone.x += 12; clone.y += 12; clone.x2 += 12; clone.y2 += 12; }
      else if (clone.type === 'path') { clone.points = clone.points.map(function (p) { return { x: p.x + 12, y: p.y + 12 }; }); }
      else { clone.x += 12; clone.y += 12; }
      clone.name = (obj.name || obj.type) + ' kopya';
      addObject(clone);
    });
    deleteBtn.addEventListener('click', function () { if (state.selectedId) deleteObject(state.selectedId); });
    clearBtn.addEventListener('click', function () {
      if (!state.objects.length) return;
      if (window.confirm('Tüm objeler silinsin mi?')) {
        state.objects = [];
        state.selectedId = null;
        renderLayers();
        redraw();
      }
    });

    /* ---------------- Dışa aktarma ---------------- */
    function downloadBlob(blob, filename) {
      var url = URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = url; a.download = filename;
      document.body.appendChild(a); a.click(); document.body.removeChild(a);
      setTimeout(function () { URL.revokeObjectURL(url); }, 2000);
    }

    function exportPNG() { canvas.toBlob(function (blob) { downloadBlob(blob, 'etiket.png'); }, 'image/png'); }
    function exportJPG() { canvas.toBlob(function (blob) { downloadBlob(blob, 'etiket.jpg'); }, 'image/jpeg', 0.92); }

    function exportSVG() {
      var parts = [];
      parts.push('<svg xmlns="http://www.w3.org/2000/svg" width="' + canvas.width + '" height="' + canvas.height + '" viewBox="0 0 ' + canvas.width + ' ' + canvas.height + '">');
      var guide = labelRect();
      parts.push('<rect x="' + guide.x + '" y="' + guide.y + '" width="' + guide.w + '" height="' + guide.h + '" fill="' + state.bgColor + '" stroke="#333" stroke-dasharray="6 5"/>');
      state.objects.forEach(function (obj) {
        if (!obj.visible) return;
        var opacity = obj.opacity != null ? obj.opacity : 1;
        var fill = typeof obj.fill === 'string' ? obj.fill : '#888';
        var stroke = typeof obj.stroke === 'string' ? obj.stroke : 'none';
        if (obj.type === 'rect') {
          parts.push('<rect x="' + obj.x + '" y="' + obj.y + '" width="' + obj.w + '" height="' + obj.h + '" fill="' + fill + '" stroke="' + stroke + '" stroke-width="' + (obj.strokeWidth || 0) + '" opacity="' + opacity + '"/>');
        } else if (obj.type === 'ellipse') {
          parts.push('<ellipse cx="' + (obj.x + obj.w / 2) + '" cy="' + (obj.y + obj.h / 2) + '" rx="' + Math.abs(obj.w / 2) + '" ry="' + Math.abs(obj.h / 2) + '" fill="' + fill + '" stroke="' + stroke + '" stroke-width="' + (obj.strokeWidth || 0) + '" opacity="' + opacity + '"/>');
        } else if (obj.type === 'line') {
          parts.push('<line x1="' + obj.x + '" y1="' + obj.y + '" x2="' + obj.x2 + '" y2="' + obj.y2 + '" stroke="' + stroke + '" stroke-width="' + (obj.strokeWidth || 2) + '" opacity="' + opacity + '"/>');
        } else if (obj.type === 'path') {
          var d = 'M ' + obj.points.map(function (p) { return p.x + ' ' + p.y; }).join(' L ') + (obj.closed ? ' Z' : '');
          parts.push('<path d="' + d + '" fill="' + (obj.closed ? fill : 'none') + '" stroke="' + stroke + '" stroke-width="' + (obj.strokeWidth || 2) + '" opacity="' + opacity + '"/>');
        } else if (obj.type === 'text') {
          var weight = obj.bold ? '700' : '400';
          var style = obj.italic ? 'italic' : 'normal';
          parts.push('<text x="' + obj.x + '" y="' + obj.y + '" font-family="' + obj.fontFamily.replace(/"/g, "'") + '" font-size="' + obj.fontSize + '" font-weight="' + weight + '" font-style="' + style + '" text-anchor="' + (obj.textAlign === 'center' ? 'middle' : obj.textAlign === 'right' ? 'end' : 'start') + '" fill="' + fill + '" opacity="' + opacity + '">' + escapeXml(obj.text || '') + '</text>');
        } else if (obj.type === 'heart') {
          parts.push('<path d="' + heartSvgPath(obj.x, obj.y, obj.w, obj.h) + '" fill="' + fill + '" stroke="' + stroke + '" stroke-width="' + (obj.strokeWidth || 0) + '" opacity="' + opacity + '"/>');
        } else if (obj.type === 'image' && obj.img) {
          parts.push('<image x="' + obj.x + '" y="' + obj.y + '" width="' + obj.w + '" height="' + obj.h + '" href="' + obj.img.src + '" opacity="' + opacity + '"/>');
        }
      });
      parts.push('</svg>');
      var blob = new Blob([parts.join('\n')], { type: 'image/svg+xml' });
      downloadBlob(blob, 'etiket.svg');
    }

    function heartSvgPath(x, y, w, h) {
      var t = h * 0.3;
      return 'M ' + (x + w / 2) + ' ' + (y + t) +
        ' C ' + (x + w / 2) + ' ' + y + ', ' + x + ' ' + y + ', ' + x + ' ' + (y + t) +
        ' C ' + x + ' ' + (y + (h + t) / 2) + ', ' + (x + w / 2) + ' ' + (y + (h + t) / 1.3) + ', ' + (x + w / 2) + ' ' + (y + h) +
        ' C ' + (x + w / 2) + ' ' + (y + (h + t) / 1.3) + ', ' + (x + w) + ' ' + (y + (h + t) / 2) + ', ' + (x + w) + ' ' + (y + t) +
        ' C ' + (x + w) + ' ' + y + ', ' + (x + w / 2) + ' ' + y + ', ' + (x + w / 2) + ' ' + (y + t) + ' Z';
    }

    function escapeXml(str) {
      return String(str).replace(/[<>&'"]/g, function (c) {
        return { '<': '&lt;', '>': '&gt;', '&': '&amp;', "'": '&apos;', '"': '&quot;' }[c];
      });
    }

    function exportPDF() {
      canvas.toBlob(function (blob) {
        var reader = new FileReader();
        reader.onload = function () {
          var jpegDataUrl = reader.result;
          buildJpegAsPdf(jpegDataUrl, function (pdfBlob) { downloadBlob(pdfBlob, 'etiket.pdf'); });
        };
        // JPEG'e çevirip PDF içine gömüyoruz (harici kütüphane olmadan minimal PDF üretimi)
        var tmp = document.createElement('canvas');
        tmp.width = canvas.width; tmp.height = canvas.height;
        var tctx = tmp.getContext('2d');
        tctx.fillStyle = '#ffffff';
        tctx.fillRect(0, 0, tmp.width, tmp.height);
        tctx.drawImage(canvas, 0, 0);
        tmp.toBlob(function (jpegBlob) {
          var r2 = new FileReader();
          r2.onload = function () {
            buildJpegAsPdf(r2.result, function (pdfBlob) { downloadBlob(pdfBlob, 'etiket.pdf'); });
          };
          r2.readAsDataURL(jpegBlob);
        }, 'image/jpeg', 0.95);
      }, 'image/jpeg', 0.95);
    }

    function buildJpegAsPdf(jpegDataUrl, callback) {
      var base64 = jpegDataUrl.split(',')[1];
      var binary = atob(base64);
      var jpegBytes = new Uint8Array(binary.length);
      for (var i = 0; i < binary.length; i++) jpegBytes[i] = binary.charCodeAt(i);

      var pxW = canvas.width, pxH = canvas.height;
      var ptW = (pxW * 72 / 96).toFixed(2);
      var ptH = (pxH * 72 / 96).toFixed(2);

      var enc = new TextEncoder();
      var chunks = [];
      var offset = 0;
      var offsets = {};
      function push(data) {
        var bytes = typeof data === 'string' ? enc.encode(data) : data;
        chunks.push(bytes);
        offset += bytes.length;
      }

      push('%PDF-1.4\n');
      offsets[1] = offset; push('1 0 obj\n<< /Type /Catalog /Pages 2 0 R >>\nendobj\n');
      offsets[2] = offset; push('2 0 obj\n<< /Type /Pages /Kids [3 0 R] /Count 1 >>\nendobj\n');
      offsets[3] = offset; push('3 0 obj\n<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ' + ptW + ' ' + ptH + '] /Resources << /XObject << /Im0 5 0 R >> >> /Contents 4 0 R >>\nendobj\n');
      var content = 'q ' + ptW + ' 0 0 ' + ptH + ' 0 0 cm /Im0 Do Q';
      offsets[4] = offset; push('4 0 obj\n<< /Length ' + content.length + ' >>\nstream\n' + content + '\nendstream\nendobj\n');
      offsets[5] = offset; push('5 0 obj\n<< /Type /XObject /Subtype /Image /Width ' + pxW + ' /Height ' + pxH + ' /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ' + jpegBytes.length + ' >>\nstream\n');
      push(jpegBytes);
      push('\nendstream\nendobj\n');
      var xrefStart = offset;
      var xref = 'xref\n0 6\n0000000000 65535 f \n';
      for (var n = 1; n <= 5; n++) xref += String(offsets[n]).padStart(10, '0') + ' 00000 n \n';
      push(xref);
      push('trailer\n<< /Size 6 /Root 1 0 R >>\nstartxref\n' + xrefStart + '\n%%EOF');

      var total = chunks.reduce(function (s, c) { return s + c.length; }, 0);
      var out = new Uint8Array(total);
      var pos = 0;
      chunks.forEach(function (c) { out.set(c, pos); pos += c.length; });
      callback(new Blob([out], { type: 'application/pdf' }));
    }

    exportDownloadBtn.addEventListener('click', function () {
      var fmt = exportFormatSelect.value;
      if (fmt === 'png') exportPNG();
      else if (fmt === 'jpg') exportJPG();
      else if (fmt === 'svg') exportSVG();
      else if (fmt === 'pdf') exportPDF();
    });

    /* ---------------- İlk çizim ---------------- */
    updateSizeReadout();
    updateGradientPreview();
    renderLayers();
    redraw();
  }

  function initAll() {
    document.querySelectorAll('[data-label-designer]').forEach(initLabelDesigner);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector ? e.target.querySelector('[data-label-designer]') : null;
    if (root) initLabelDesigner(root);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
